<script lang="ts" setup>
import { SimpleErrorParagraphProps } from "~/components/Utils/SimpleErrorParagraph.interface"

const { message } = defineProps<SimpleErrorParagraphProps>()
</script>

<template>
  <p class="mouse my-3 text-negative-main">
    {{ message }}
  </p>
</template>
